/**
 * What every client selects of a `RunState` (docs/carrier-runs.md#live-state). AppSync sends a
 * subscriber only the fields the mutation that triggered it selected, so the daemon's
 * `reportRunState` and the admin portal's subscriptions select exactly this. A module of its own,
 * without zod, so the portal's bundle takes only this line.
 */
export const RUN_STATE_FIELDS =
  "runId revision state holder { producerId email machineId segmentId } page { url title } lastActivityAt lastTool { name ok } updatedAt";
